import { ReactElement } from 'react';
import styled from 'styled-components';
import { CredusHeading, CredusText, CredusWrapper } from 'ui';

type OverViewCardProp = {
  icon: ReactElement;
  desc: string;
  value: number | string;
};

const OverviewCard = ({ icon, value, desc }: OverViewCardProp) => (
  <CardWraper>
    <CredusWrapper
      pt="1.3rem"
      pb="1.8rem"
      display="flex"
      direction="column"
      align="center"
    >
      {icon}
      <CredusHeading mt="1.2rem" align="center" color="#FB0200" as="h3">
        {value ? value : '-'}
      </CredusHeading>
      <CredusText
        mt="0.5rem"
        weight="regular"
        color="rgba(24, 24, 25, 0.71);"
        size="md"
        align="center"
      >
        {desc}
      </CredusText>
    </CredusWrapper>
  </CardWraper>
);

export default OverviewCard;

const CardWraper = styled.div`
  height: 202px;
  background: #ffffff;
  border: 0.5px solid #e6e6e6;
  border-radius: 5px;
`;
